module.exports = __webpack_public_path__ + "static/media/和伙伴.b7f2f1ff.png";